import React from "react";

interface LabelValueRowProps {
  label: string;
  value: React.ReactNode;
  bold?: boolean;
  className?: string;
}

const LabelValueRow: React.FC<LabelValueRowProps> = ({ label, value, bold = false, className = "" }) => {
  return (
    <div className={`flex justify-between mb-1 ${bold ? "font-bold" : ""} ${className}`}>
      <div>{label}</div>
      <div>{value}</div>
    </div>
  );
};

export default LabelValueRow;
